import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';

const Hero = () => {
  const { t } = useTranslation();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              {t('hero-title-main')}
              <span className="highlight">{t('hero-title-highlight')}</span>
              {t('hero-title-end')}
            </h1>
            <p className="hero-subtitle">
              {t('hero-subtitle')}
            </p>
            <div className="hero-action">
              <a 
                href="#pricing" 
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('pricing');
                }}
              >
                {t('hero-cta')} <i className="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="dashboard-mockup">
              <div className="mockup-header">
                <div className="mockup-dots">
                  <span className="dot red"></span>
                  <span className="dot yellow"></span>
                  <span className="dot green"></span>
                </div>
                <div className="mockup-url">https://your-business.com</div>
              </div>
              <div className="mockup-content">
                <div className="progress-bars">
                  <div className="progress-item">
                    <div className="progress-bar">
                      <div className="progress-fill" style={{ width: '85%' }}></div>
                    </div>
                  </div>
                  <div className="progress-item">
                    <div className="progress-bar">
                      <div className="progress-fill" style={{ width: '92%' }}></div>
                    </div>
                  </div>
                  <div className="progress-item">
                    <div className="progress-bar">
                      <div className="progress-fill" style={{ width: '78%' }}></div>
                    </div>
                  </div>
                </div>
                <div className="analytics-card">
                  <h4>Registration Dashboard</h4>
                  <div className="metric">
                    <span className="metric-value">2,847</span>
                    <span className="metric-growth">↗ +24.5%</span>
                  </div>
                  <p className="metric-label">COMPANIES FORMED</p>
                  <div className="chart-line">
                    <svg width="100%" height="40" viewBox="0 0 100 40">
                      <path d="M5,35 Q25,15 45,25 T85,10" stroke="#677DB7" strokeWidth="2" fill="none"/>
                    </svg>
                  </div>
                </div>
                <div className="status-items">
                  <div className="status-item">
                    <div className="status-dot active"></div>
                    <span>UK Ltd Formation</span>
                  </div>
                  <div className="status-item">
                    <div className="status-dot active"></div>
                    <span>Delaware Corp</span>
                  </div>
                  <div className="status-item">
                    <div className="status-dot active"></div>
                    <span>Singapore Pte Ltd</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-stats">
          <div className="stat">
            <h3>2,500+</h3>
            <p>{t('hero-stats-companies')}</p>
          </div>
          <div className="stat">
            <h3>98%</h3>
            <p>{t('hero-stats-satisfaction')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 